"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GalReport = void 0;
const local_id_1 = require("../class/local-id");
const logger_1 = require("../class/logger");
const dto_hash_1 = require("../helpers/dto-hash");
const fingerprint_1 = require("../helpers/fingerprint");
const request_1 = require("../helpers/request");
const config_1 = __importDefault(require("../config"));
require("isomorphic-fetch");
const EVENT_RETRY_LIMIT = config_1.default.eventSubmitRetryLimit;
const EVENT_RETRY_DELAY_MS = config_1.default.eventSubmitRetryDelayMS;
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
class GalReport {
    constructor(args) {
        var _a;
        Object.defineProperty(this, "args", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: args
        });
        Object.defineProperty(this, "fingerprint", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "localId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "idSource", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new dto_hash_1.DTOHash()
        });
        Object.defineProperty(this, "request", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "urlBase", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "obscure", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "failOnReportError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        this.urlBase = `${this.trimSlashes(args.reportingUri)}/${this.trimSlashes(config_1.default.apiVersionPath)}`;
        this.obscure = args.obscure;
        this.failOnReportError = (_a = args.failOnReportError) !== null && _a !== void 0 ? _a : false;
        const opts = {
            baseURL: args.obscure
                ? `${this.urlBase}/r`
                : `${this.urlBase}/report/${this.trimSlashes(args.reportingGroup)}`,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `bearer ${this.encode(args.publisherId)}`,
            },
        };
        this.request = new request_1.FetchRequest(opts);
        this.localId = new local_id_1.LocalId();
        this.fingerprint = new fingerprint_1.Fingerprint({
            endpoint: this.args.fpEndpoint,
            apiKey: config_1.default.fingerprintJS.apiKey,
            scriptUrls: config_1.default.fingerprintJS.scriptUrls,
        });
    }
    async send(report, elapsedAtReportTime, asBeacon = false) {
        var _a, _b;
        const event = {
            ...report,
            fingerprint: await this.fingerprint.identify(),
            localId: this.localId.getId(),
            prevId: this.idSource.prev,
            elapsedAtReportTime,
            environment: this.args.environment,
        };
        const type = report.details.type;
        const reportEvent = this.obscure
            ? this.sendObscured.bind(this)
            : this.sendDirect.bind(this);
        let errorMessage = '';
        let attempts = 0;
        while (++attempts <= EVENT_RETRY_LIMIT) {
            try {
                const response = await reportEvent(type, {
                    ...event,
                    id: await this.idSource.makeId(event),
                }, asBeacon);
                if (`${response === null || response === void 0 ? void 0 : response.status}`.startsWith('2') ||
                    `${response === null || response === void 0 ? void 0 : response.status}`.startsWith('3')) {
                    return;
                }
                else if (`${response === null || response === void 0 ? void 0 : response.status}`.startsWith('4')) {
                    errorMessage = `Reporting failed with ${response === null || response === void 0 ? void 0 : response.status}: ${JSON.stringify((_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : {})}`;
                    logger_1.Logger.error(errorMessage);
                    break;
                }
                errorMessage = `Reporting failed with ${response === null || response === void 0 ? void 0 : response.status}: ${JSON.stringify((_b = response === null || response === void 0 ? void 0 : response.body) !== null && _b !== void 0 ? _b : {})}`;
                logger_1.Logger.warn(errorMessage);
                console.error(EVENT_RETRY_DELAY_MS, attempts, response);
                await delay(EVENT_RETRY_DELAY_MS * attempts);
            }
            catch (err) {
                logger_1.Logger.handle(err);
                errorMessage = 'Unknown error reporting event';
                await delay(EVENT_RETRY_DELAY_MS * attempts);
            }
        }
        if ((errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.length) && this.failOnReportError) {
            throw new Error(errorMessage);
        }
    }
    async sendDirect(type, event, asBeacon = false) {
        return this.request.post(type, event, asBeacon);
    }
    async sendObscured(type, event, asBeacon = false) {
        return this.request.post('', {
            r: this.encode(JSON.stringify({
                body: event,
                group: this.args.reportingGroup,
                type,
            })),
        }, asBeacon);
    }
    trimSlashes(str) {
        str = str.trim();
        if (str.endsWith('/')) {
            str = str.substring(0, str.length - 1);
        }
        if (str.startsWith('/')) {
            str = str.substring(1);
        }
        return str;
    }
    encode(str) {
        if (typeof window !== 'undefined' && (window === null || window === void 0 ? void 0 : window.btoa)) {
            return window.btoa(str);
        }
        else {
            return Buffer.from(str).toString('base64');
        }
    }
}
exports.GalReport = GalReport;
